import React from 'react';
import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import './App.css';

const App = () => <SwaggerUI url="./joyn2-integration-api.yaml" defaultModelsExpandDepth={0} />;
export default App;
